import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import Icon from '../../../atoms/Icon';
import getTeaserDetailById from '../api/getContentHubTeaserbyId';
import ContentHubTeaserCardDynamic from './ContentHubTeaserCardDynamic';
import ContentHubTeaserDynamicMobile from './ContentHubTeaserDynamicMobile';

import renderElements from '~/helpers/renderer/renderer';
import { ContainerLargeType } from '../../../molecules/ContainerLarge/ContainerLarge.helpers';
import {
  ContentHubDynamicShowMore,
  ContentHubDynamicContent,
  ContentHubStyle3,
} from '../ContentHubTeaser.styles';
import {
  pushEvent,
  dataLayerEvents,
  dataLayerActions,
} from '~/helpers/datalayer';
import useIsMobile from '~/hooks/useIsMobile';

/**
 * @param {ContentHubTeaserDynamicWrapperProps} props
 * @returns {React.ReactElement} The rendered component
 */
export default function ContentHubTeaserDynamicWrapper({
  teasers = [],
  language,
}) {
  const intl = useIntl();
  const [teaserSelected, setTeaserSelected] = useState({
    id: teasers[0].id,
    index: 0,
  });
  const [teaserContent, setTeaserContent] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const isMobile = useIsMobile({ useMq: 'mdDown' });
  const nextTeaserIndex =
    (teaserSelected.index + teasers?.length + 1) % teasers?.length;

  const prevTeaserIndex =
    (teaserSelected.index + teasers?.length - 1) % teasers?.length;

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (teaserSelected && teaserSelected.id) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setShowMore(false);
      getTeaserDetailById(teaserSelected.id, intl?.locale || language).then(
        ({ status, data }) => {
          if (status === 'OK') {
            setTeaserContent(data);
          }
        },
      );
    }
  }, [teaserSelected]);
  /* eslint-enable react-hooks/exhaustive-deps */

  if (!teasers.length || teasers.length === 0) {
    return <></>;
  }

  return (
    <div>
      {isMobile ? (
        <ContentHubTeaserDynamicMobile
          teaser={teasers.find((teaser) => teaser.id === teaserSelected.id)}
          setNextTeaser={() =>
            setTeaserSelected({
              id: teasers[nextTeaserIndex].id,
              index: nextTeaserIndex,
            })
          }
          setPrevTeaser={() =>
            setTeaserSelected({
              id: teasers[prevTeaserIndex].id,
              index: prevTeaserIndex,
            })
          }
        />
      ) : (
        <ContentHubStyle3>
          {teasers.map((teaser, index) => (
            <ContentHubTeaserCardDynamic
              key={teaser.id}
              format={'square'}
              withDescription={false}
              isSelected={teaserSelected.id === teaser.id}
              onClick={() => setTeaserSelected({ id: teaser.id, index })}
              {...teaser}
            />
          ))}
        </ContentHubStyle3>
      )}
      {teaserContent && teaserContent.length > 0 && (
        <>
          <ContentHubDynamicContent showMore={showMore} isMobile={isMobile}>
            {renderElements(
              teaserContent,
              undefined,
              undefined,
              undefined,
              ContainerLargeType.B1,
            )}
          </ContentHubDynamicContent>
          {!showMore && (
            <ContentHubDynamicShowMore
              onClick={() => {
                setShowMore(true);
                pushEvent({
                  event: dataLayerEvents.CONTENT_HUB_TEASER_MEHR_ANZEIGEN_CLICK,
                  action: dataLayerActions.TEASER_CLICK,
                  label: teaserContent[0]?.title || '',
                  payload: teaserContent[0]?.topic || '',
                });
              }}
            >
              <Icon icon="ARROW_CTA" />
              {intl.formatMessage({
                id: 'contentHub.teasers.dynamic.showMore',
              })}
            </ContentHubDynamicShowMore>
          )}
        </>
      )}
    </div>
  );
}
